import { Element, ElementModuleElement } from './element';

export class ElementModuleElementGrid extends ElementModuleElement {
  constructor() {
    super();
    this.type = 'module-element';
    this.typeElement = 'grid';
  }
}
